<template>
  <FreeBottomSheet :name="name">
    <template #header="{ hide }">
      <FreeHeader class="p-4">
        <template #default>
          <h3 class="text-text-neutral-primary text-base font-medium">
            {{ t('details.smartRoute.title') }}
          </h3>
        </template>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <section
        class="bg-background-neutral-secondary mx-4 space-y-4 rounded-2xl p-4"
      >
        <p class="text-text-neutral-primary text-base">
          {{ t('details.smartRoute.description') }}
        </p>
        <ul class="space-y-4">
          <li
            v-for="(item, idx) in infoItems"
            :key="idx"
            class="flex items-start space-x-2"
          >
            <component :is="item.icon" class="shrink-0" />
            <div class="space-y-1">
              <h4 class="text-text-neutral-primary text-base font-semibold">
                {{ item.title }}
              </h4>
              <p class="text-text-neutral-primary text-base">
                {{ item.description }}
              </p>
            </div>
          </li>
        </ul>
      </section>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { FreeBottomSheet, FreeHeader, FreeCloseButton } from 'freedom-shared';

  import BaggageIcon from '@/assets/images/smart-route/baggage.svg?component';
  import VisaIcon from '@/assets/images/smart-route/visa.svg?component';
  import RefundExchangeIcon from '@/assets/images/smart-route/refund-exchange.svg?component';

  defineProps<{
    name: string;
  }>();

  const { t } = useI18n();

  const infoItems = [
    {
      title: t('details.smartRoute.baggage.title'),
      description: t('details.smartRoute.baggage.description'),
      icon: BaggageIcon,
    },
    {
      title: t('details.smartRoute.visa.title'),
      description: t('details.smartRoute.visa.description'),
      icon: VisaIcon,
    },
    {
      title: t('details.smartRoute.refundExchange.title'),
      description: t('details.smartRoute.refundExchange.description'),
      icon: RefundExchangeIcon,
    },
  ];
</script>
